import { StorageKey } from "../constants";

type IStorageKey = keyof typeof StorageKey;

const TAG = "StorageUtil";

// 用户私有KEY，需要带上用户ID前缀
const privateKeys: IStorageKey[] = ["RECENT_EMOJI"];

let namespace = "";

function getStorageKey(key: IStorageKey) {
  return privateKeys.includes(key)
    ? namespace + StorageKey[key]
    : StorageKey[key];
}

/**
 * 初始化缓存
 */
function init(id: string) {
  namespace = id;
}

/**
 * 获取缓存值
 * @param key 键值
 * @param parse 是否解析成JOSN
 */
async function getItem(key: IStorageKey, parse?: boolean) {
  try {
    const value = await localStorage.getItem(getStorageKey(key));
    if (!value) {
      return null;
    }
    return parse ? JSON.parse(value) : value;
  } catch (error) {
    console.error(TAG, "getItem", error);
    return null;
  }
}

async function setItem(key: IStorageKey, value: string | number | object) {
  try {
    let text = "";
    if (typeof value === "string") {
      text = value;
    } else if (typeof value === "number") {
      text += value;
    } else {
      text = JSON.stringify(value);
    }
    await localStorage.setItem(getStorageKey(key), text);
    return true;
  } catch (error) {
    console.error(TAG, "setItem", error);
    return false;
  }
}

async function removeItem(key: IStorageKey) {
  try {
    await localStorage.removeItem(getStorageKey(key));
    return true;
  } catch (error) {
    console.error(TAG, "removeItem", error);
    return false;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  init,
  getItem,
  setItem,
  removeItem,
};
